import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, Heart } from 'lucide-react';
import Seo from '@/seo/Seo';

export default function DonateCancelled() {
  return (
    <div>
      <Seo
        title="Donation Cancelled | Ministry of Jesus"
        titleExact
        description="Your donation to Ministry of Jesus was cancelled before completing. You can try again any time."
        path="/donate/cancelled"
        noindex
      />
      <section className="py-20 bg-moj-cream min-h-[70vh] flex items-center">
        <div className="max-w-xl mx-auto px-4 sm:px-6 text-center card-moj p-8 sm:p-12" data-testid="donate-cancelled-card">
          <XCircle size={48} className="text-moj-gold-deep mx-auto mb-4"/>
          <h1 className="font-serif text-3xl text-moj-purple-deep mb-2">Donation Cancelled</h1>
          <p className="text-moj-charcoal/85 mb-6">
            No payment has been taken. You can return to the donation page and try again at any time.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/donate" className="btn-primary" data-testid="donate-cancelled-retry"><Heart size={16}/> Try Again</Link>
            <Link to="/" className="btn-outline"><ArrowLeft size={16}/> Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
